import { supabase } from '../../lib/supabase';
import { throwFunctionsInvokeError } from '../../lib/functionsInvoke';
import { MetaIntegrationData, MetaIntegrationStatus } from './metaTypes';

/**
 * Salva a integração Meta via Edge Function (token nunca persiste no client).
 */
export const saveMetaIntegration = async (
    integrationData: MetaIntegrationData,
    organizationId: string
): Promise<void> => {
    const { data, error } = await supabase.functions.invoke('save-meta-integration', {
        body: {
            organization_id: organizationId,
            short_token: integrationData.accessToken,
            account: integrationData.account,
            pixel: integrationData.pixel,
            page: integrationData.page,
        },
    });

    if (error || data?.error) {
        await throwFunctionsInvokeError(data, error, 'Erro ao salvar integração Meta');
    }
};

/**
 * Busca a integração Meta existente (sem credentials).
 */
export const getMetaIntegration = async (organizationId: string): Promise<MetaIntegrationStatus | null> => {
    try {
        const { data, error } = await supabase
            .from('integrations')
            .select('name, config, status')
            .eq('organization_id', organizationId)
            .eq('type', 'meta_ads')
            .eq('status', 'connected')
            .maybeSingle();

        if (error || !data) {
            return null;
        }

        return {
            connected: true,
            accountName: data.name,
            pixelName: data.config?.pixel_name,
            pageName: data.config?.page_name,
            expiresAt: data.config?.expires_at,
        };
    } catch {
        return null;
    }
};

/**
 * Remove uma integração Meta
 */
export const removeMetaIntegration = async (organizationId: string): Promise<void> => {
    const { error } = await supabase
        .from('integrations')
        .delete()
        .eq('organization_id', organizationId)
        .eq('type', 'meta_ads');

    if (error) {
        console.error('[MetaRepository] Error removing integration:', error);
        throw new Error(`Erro ao remover integração: ${error.message}`);
    }
};
